type MakeOpenRouteParams = {
  demo: boolean;
  host?: any;
  toast?: any;
  onClose?: () => void;
};

export function makeOpenRoute({ demo, host, toast, onClose }: MakeOpenRouteParams) {
  return (
    demoPath: string | null,
    buildProdPath: () => string | null,
    opts?: { checkPremium?: boolean }
  ) => {
    if (onClose) onClose();

    // If running in demo, prefer demo route and skip premium checks
    if (demo && demoPath) {
      window.open(`${window.location.origin}${demoPath}`, '_blank', 'noopener,noreferrer');
      return;
    }

    if (opts?.checkPremium && host?.subscription_level !== 'enterprise') {
      toast?.({
        title: 'Enterprise Feature',
        description: 'Show Mode is available for Enterprise hosts only',
        variant: 'destructive',
      });
      return;
    }

    const prod = buildProdPath();
    if (prod) {
      window.open(`${window.location.origin}${prod}`, '_blank', 'noopener,noreferrer');
    }
  };
}

export default makeOpenRoute;
